import {
    addPlacementRequest,
    deletePlacementRequest,
    editPlacementRequest,
    getPlacementListRequest,
    getPlacementRequest,
    updatePlacementRequest,
} from '../../../../services/network/region_services/placement';

class CommonPlacementService {
    async addPlacement(values) {
        return await addPlacementRequest(values);
    }

    async getPlacement(id) {
        return await getPlacementRequest(id);
    }

    async getPlacementList(payload) {
        return await getPlacementListRequest(payload);
    }

    async deletePlacement(id) {
        return await deletePlacementRequest(id);
    }

    async editPlacement(updates) {
        return await editPlacementRequest(updates);
    }

    async updatePlacement(updates) {
        return await updatePlacementRequest(updates);
    }
}

export const PlacementService = new CommonPlacementService();
